<ng-container *ngIf="selectorTpl != null; else elseTpl">
  <div (click)="setCurrentDate()">
    <ng-container *ngTemplateOutlet="selectorTpl; context: {item: value}"></ng-container>
  </div>
</ng-container>
<ng-template #elseTpl>
  <ion-item [class.invalid]="isInvalid() && isTouched()">
    <label class="label-text">{{obligatorio ? '* ' : ''}}{{label}}</label>
    <ion-button slot="end" *ngIf="value != null && value != ''; else dateNotSet" fill="clear" class="ion-text-right">{{value}}</ion-button>
    <ng-template #dateNotSet>
      <ion-button slot="end" fill="clear" (click)="setCurrentDate()" class="ion-text-right">Establecer fecha actual</ion-button>
    </ng-template>
  </ion-item>
</ng-template>